import React from "react";
import { ShieldCheck, Navigation, Sparkles, CalendarClock, FileCheck, Banknote, Car, Key, Apple, Zap, Wifi, Armchair } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const features = [{
  subtitle: "ERGONOMISCHES SETUP.",
  title: "Dein Rücken wird's dir danken.",
  description: "Ergonomischer Arbeitsplatz: Höhenverstellbare Tische. Stühle, die mitmachen, auch nach 8 Stunden.",
  icon: Armchair
}, {
  subtitle: "DIGITALE FREIHEIT.",
  title: "Internet, das einfach läuft.",
  description: "Highspeed-Wlan: Videocalls, Uploads, alles gleichzeitig. Kein Ruckeln. Kein Ausfall.",
  icon: Wifi
}, {
  subtitle: "KULINARISCHER TREFFPUNKT.",
  title: "Kaffee ist fertig.",
  description: "Voll ausgestattete Küche. Vom Kühlschrank bis zur Maschine. Mittagessen wie zu Hause, nur mit besserer Gesellschaft.",
  icon: Apple
}, {
  subtitle: "SORGLOSE ANFAHRT.",
  title: "Ankommen. Aussteigen. Loslegen.",
  description: "Kostenlose Parkplätze direkt am Gebäude. Kein Suchen und kein Ticket.",
  icon: Car
}, {
  subtitle: "SMARTE E-MOBILITÄT.",
  title: "Dein Auto lädt, während du arbeitest.",
  description: "E-Ladesäule auf Wunsch, direkt vor der Tür. Einfach anschließen und den Kopf bei der Arbeit lassen.",
  icon: Zap
}, {
  subtitle: "PERSÖNLICHES DEPOT.",
  title: "Dein Fach. Dein Kram. Sicher.",
  description: "Ein persönliches Schließfach für alles, was du nicht jeden Tag mitschleppen willst.",
  icon: Key
}];
export default function WarumHundetransport24() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="5543" id="das-erwartet-dich" ref={sectionRef} className="bg-[#EEEEEE] ![padding:144px_0px_144px_0px]">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className="grid grid-cols-1 lg:grid-cols-[1fr_2fr] gap-12">
      {/* Left: Header */}
      <div className={cn("flex flex-col justify-between transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <div>
          <span className="text-sm font-semibold uppercase tracking-widest text-[#888888] mb-4 block">Ausstattung</span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-6">
            <span className="text-[#141414]">Alles da.</span><br />
            <span className="text-[#888888]">Alles durchdacht.</span>
          </h2>
        </div>
        <div>
          <div className="flex flex-wrap gap-2 mb-6">
            <span className="inline-block rounded-full bg-[#141414]/5 border border-[#141414]/10 px-4 py-2 text-sm font-medium text-[#555555]">Wohlbefinden</span>
            <span className="inline-block rounded-full bg-[#141414]/5 border border-[#141414]/10 px-4 py-2 text-sm font-medium text-[#555555]">Komfort</span>
          </div>
          <p className="text-base text-[#555555] leading-relaxed">
            Ein guter Arbeitsplatz ist mehr als ein Schreibtisch. Es ist das Gefühl, anzukommen und loslegen zu können. Genau das haben wir gebaut.
          </p>
        </div>
      </div>
      {/* Right: Feature Grid */}
<div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
  {features.map((feature, index) => <div key={feature.title} data-index={index} className={cn("transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")} style={{
            transitionDelay: `${index * 100}ms`
          }}>
      <div className="group h-full rounded-2xl bg-white/60 backdrop-blur-sm p-8 transition-all duration-300 hover:bg-white hover:shadow-lg cursor-default">
        <div className="flex items-center gap-3 mb-3">
          <feature.icon className="size-4 text-[#FF6F61]" />
          <span className="text-xs font-semibold uppercase tracking-widest text-[#FF6F61]">
            {feature.subtitle}
          </span>
        </div>
        <h3 className="text-lg font-bold text-[#141414] mb-4">
          {feature.title}
        </h3>
        <p className="text-sm leading-relaxed text-[#555555]">
          {feature.description}
        </p>
      </div>
    </div>)}
</div>
    </div>
  </div>
  </section>;
}